import { render, staticRenderFns } from "./AdminRelations.vue?vue&type=template&id=28818802&scoped=true"
import script from "./AdminRelations.vue?vue&type=script&lang=js"
export * from "./AdminRelations.vue?vue&type=script&lang=js"
import style0 from "./AdminRelations.vue?vue&type=style&index=0&id=28818802&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28818802",
  null
  
)

export default component.exports